import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";

/** Normalized row for routing table UI + client filters (current page). */
export type BbaasRoutingTableDisplayRow = {
	rowKey: string;
	prefix: string;
	nextHop: string;
	sourceName: string;
	vrf: string;
	connectedServiceType: string;
	asPath: string;
	neighborAsn: number;
	lp: number;
	med: number;
	community: string;
	origin: string;
	direction: string;
	best: boolean;
};

export const ROUTING_API_TABLE_HEADERS = [
	"Prefix",
	"Neighbor",
	"Source",
	"VRF",
	"Type",
	"AS Path",
	"Neighbor ASN",
	"LP",
	"MED",
	"Community",
	"Origin",
	"Direction",
	"Best",
];

export function makeRoutingApiFields(): FilterField<BbaasRoutingTableDisplayRow>[] {
	const fields: FilterField<BbaasRoutingTableDisplayRow>[] = [
		{
			label: "Prefix",
			key: "prefix",
			accessor: (r) => r.prefix,
			type: "string",
			inFreeText: true,
		},
		{
			label: "Neighbor",
			key: "neighbor",
			accessor: (r) => r.nextHop,
			type: "string",
			inFreeText: true,
		},
		{
			label: "Source",
			key: "source",
			accessor: (r) => r.sourceName,
			type: "string",
			inFreeText: true,
		},
		{
			label: "VRF",
			key: "vrf",
			accessor: (r) => r.vrf,
			type: "string",
			inFreeText: true,
		},
		{
			label: "Type",
			key: "type",
			accessor: (r) => r.connectedServiceType,
			type: "string",
			inFreeText: true,
		},
		{
			label: "AS Path",
			key: "aspath",
			accessor: (r) => r.asPath,
			type: "string",
			inFreeText: true,
		},
		{
			label: "Neighbor ASN",
			key: "neighborasn",
			accessor: (r) => String(r.neighborAsn),
			type: "string",
			inFreeText: true,
		},
		{
			label: "LP",
			key: "lp",
			accessor: (r) => String(r.lp),
			type: "number",
			inFreeText: true,
		},
		{
			label: "MED",
			key: "med",
			accessor: (r) => String(r.med),
			type: "number",
			inFreeText: true,
		},
		{
			label: "Community",
			key: "community",
			accessor: (r) => r.community,
			type: "string",
			inFreeText: true,
		},
		{
			label: "Origin",
			key: "origin",
			accessor: (r) => r.origin,
			type: "string",
			inFreeText: true,
		},
		{
			label: "Direction",
			key: "direction",
			accessor: (r) => r.direction,
			type: "string",
			inFreeText: true,
		},
		{
			label: "Best",
			key: "best",
			accessor: (r) => (r.best ? "Yes" : "No"),
			type: "string",
			inFreeText: true,
		},
	];
	for (const f of fields) f.key ??= labelId(f.label);
	return fields;
}
